import React, {
  PureComponent,
} from 'react';
import {
  View,
  StyleSheet,
  PixelRatio,
  TextInput,
  TouchableOpacity
} from 'react-native';
import {
  JDImage,
  JDDevice,
  JDText,
  JDTouchableWithoutFeedback,
} from '@jdreact/jdreact-core-lib';
import { pt, sendClickDataWithJsonParam } from '../../../../components/utiles';
const dpr = parseInt(PixelRatio.get(), 10) || 1;

export default class SearchBar extends PureComponent {
  static defaultProps = {
    keyword: '',
    cityName: '',
    placeholder: '',
    autoFocus: false,
    customStyle: {},
    handleFocus: () => {},
    handleBlur: () => {},
    search: () => {},
    deletWordFocus: () => {},
}
  constructor (props) {
    super(props);
    this.state = {
      myAutoFocus: this.props.autoFocus,
      myKeyword: this.props.keyword
    }
    this.onChangeText = this.onChangeText.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.JDSearchInput = React.createRef();
  }

  onKeyPress = (e) => {
      const {nativeEvent} = e
      const {key} = nativeEvent
      if(key === 'Enter' ){
        this.search()
      }
  }

  onChangeText = (item) => { 
    this.setState({
      myKeyword: item
    })
  }

onFocus = () => {
  const { handleFocus} = this.props;
  handleFocus(this.state.myKeyword);
}

onBlur = () => {
  const { handleBlur} = this.props;
  handleBlur(this.state.myKeyword);
}

search = () => {
  sendClickDataWithJsonParam({
    event_id: 'OfficeBuilding_SearchList_SearchConfirm',
    page_id: this.props.pageId,
    json_param: {
        searchword: this.state.myKeyword
    },
  })
  this.props.search(this.state.myKeyword);
}

clearKeyword = () => {
  this.setState({
    myKeyword: '',
    myAutoFocus: true
  },()=>{
    setTimeout(()=>{
      this.setState({
        myAutoFocus: true
      })
    },100)
    this.JDSearchInput.current &&  this.JDSearchInput.current.clear();
  })
}


  render() {
    const { placeholder, cityName, customStyle, beforeBack} = this.props 
    const { myKeyword ,myAutoFocus} = this.state
    return (
      <View style={[styles.searchBarBox, customStyle]}>
          {/* <JDTouchableWithoutFeedback onPress={beforeBack} contentContainerStyle={styles.backIconBox}>
            <JDImage source={{
                  uri: 'https://misc.360buyimg.com/m/auction-my/images/back.png'
              }} style={styles.backIcon} />
          </JDTouchableWithoutFeedback> */}
          
          <View style={styles.searchBar}>
              {/* <View style={styles.searchArea_box}>
                    <JDTouchableWithoutFeedback onPress={()=>{}} style={styles.city_box}>
                      <View style={[styles.center, styles.city_cont]}>
                        <JDText style={[styles.searchAddrTxt, cityName.length > 2 ? styles.widthL : styles.widthS]} numberOfLines={1}>
                          {cityName || "北京"}
                        </JDText>
                      </View>
                    </JDTouchableWithoutFeedback>
              </View> */}
              <View style={[styles.searchInputBlock]}>
                  <View style={styles.inputLine}></View>
                  <TextInput
                      autoFocus={myAutoFocus}
                      onSubmitEditing={this.search}
                      ref={this.JDSearchInput}
                      style={[styles.searchInput]}
                      placeholder={placeholder}
                      placeholderTextColor={'#CCCCCC'}
                      value={myKeyword}
                      onFocus={this.onFocus}
                      onBlur={this.onBlur}
                      onChangeText={(value) => this.onChangeText(value, 'onChangeText')}
                      onKeyPress={(value) => this.onKeyPress(value)}
                      // inputMode={'search'}
                      // onEndEditing={(value) => this.onChangeText(value, 'onEndEditing')}
                      // enterKeyHint={'search'}
                      // onChange={(value) => this.onChangeText(value, 'onChange')}
                      
                  /> 
                  {(myKeyword !== '') && <TouchableOpacity onPress={this.clearKeyword} style={styles.deleIconBox}>
                      <JDImage source={{
                          uri: 'https://img13.360buyimg.com/imagetools/jfs/t1/30458/33/18594/2967/63350a67E53466c5d/eaea0ac810a25bab.png'
                      }} style={styles.deleIcon} />
                  </TouchableOpacity>}
              </View>
              <TouchableOpacity onPress={this.search} style={styles.searchIconBox}>
                <JDImage source={{
                      uri: 'https://img11.360buyimg.com/imagetools/jfs/t1/93419/32/32547/3675/633508e2Eeb36fe28/75d56b961e42520a.png'
                  }} style={styles.searchIcon} />
              </TouchableOpacity>
          </View>
      </View>
    );
  }
}
const styles = StyleSheet.create({
  searchBarBox: {
    marginTop: pt(28),
    marginBottom: pt(28),
    position: 'relative',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row'
  },
  searchBar: {
    width: pt(652),
    position: 'relative',
    height: JDDevice.getRpx(80),
    backgroundColor: '#ffffff',
    borderRadius: JDDevice.getRpx(40),
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    marginRight: pt(32)
  },
searchInputBlock: {
    width: pt(560),
    height: pt(80),
    flexDirection: 'row',
    alignItems: 'center'
},
searchInput: {
  width: pt(468),
  height: pt(80),
  paddingVertical: 0,
  justifyContent: 'center'
},
inputLine: {
  width: pt(1),
  height: pt(40),
  marginRight: pt(44),
  backgroundColor:'#f6f6f6'
},
deleIconBox: {
  width: pt(70),
  height: pt(80),
  justifyContent: 'center',
  paddingHorizontal: pt(20),
},
deleIcon: {
  width: pt(28),
  height: pt(28),
  marginLeft: pt(10),
  marginRight: pt(10)
},
searchIconBox: {
  width: pt(80),
  height: pt(80),
  justifyContent: 'center',
  paddingRight:pt(40),
  paddingLeft: pt(10),
},
searchIcon: {
    width: pt(30),
    height: pt(30)
},
backIconBox: {
  width: pt(82),
  height: pt(80),
  justifyContent: 'center',
  paddingRight:pt(30),
  paddingLeft: pt(30),
},
backIcon: {
    width: pt(22),
    height: pt(34)
},
  
})